import { useId, useRef, type KeyboardEvent } from 'react'
import { Icon } from '../../components/Icon'

export interface SettingsSectionMenuItem {
  id: string
  label: string
  current?: boolean
}

interface Props {
  open: boolean
  items: readonly SettingsSectionMenuItem[]
  onOpenChange: (open: boolean) => void
  onSelect: (id: string) => void
}

/** Compact access to the existing Settings destinations from the persistent header. */
export function SettingsSectionMenu({ open, items, onOpenChange, onSelect }: Props) {
  const menuId = useId()
  const toggleRef = useRef<HTMLButtonElement>(null)

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!open || event.key !== 'Escape') return
    event.preventDefault()
    event.stopPropagation()
    onOpenChange(false)
    toggleRef.current?.focus({ preventScroll: true })
  }

  return <div className="settings-section-menu" onKeyDown={handleKeyDown}>
    <button
      ref={toggleRef}
      className="btn btn-ghost btn-square settings-section-menu__toggle"
      type="button"
      aria-label="Show settings sections"
      aria-controls={menuId}
      aria-expanded={open}
      onClick={() => onOpenChange(!open)}
    ><Icon name="list" /></button>
    {open ? <nav id={menuId} className="settings-section-menu__popover studio-dropdown" aria-label="Settings sections">
      <ul className="menu menu-vertical">
        {items.map(item => <li key={item.id}><button
          type="button"
          aria-current={item.current ? 'page' : undefined}
          onClick={() => onSelect(item.id)}
        >{item.label}</button></li>)}
      </ul>
    </nav> : null}
  </div>
}
